<template>
    <div class="barcode-container" >
      <van-tabs v-model:active="active" @change="onTabChange" color="#67C23A">
        <van-tab v-for="item in barcodeList" :key="item.label" :title="item.label"></van-tab>
      </van-tabs>
      <div class="barcode" v-if="barcodeList[active] && barcodeList[active].value">
        <canvas ref="barcodeCanvas" style="height: 100px"></canvas>
        <div class="bar-text" v-if="barcodeList[active]">{{ barcodeList[active].value }}</div>
      </div>
      <div class="empty" v-else>-空-</div>
      <div class="bar-massage">注：扫描时进销存系统请用英文输入法</div>
      </div>
</template>

<script>
import bwipjs from 'bwip-js';
    export default {
        data() {
            return {
                barcodeOpts: {
                    bcid: "code128",       // 条形码类型
                    text: "",       // 内容
                    scale: "2",     // 缩放比例
                    height: 8,   // 高度
                    includetext: false,      // 显示文本
                    width: 30
                },
                active: 0, // 当前激活的标签页
                // 不同标签页的条形码内容
                barcodeList: []
            }
        },
        mounted() {
            this.barcodeList = this.barList
            this.barcodeOpts.text = this.barcodeList[0].value
            this.generateBarcode()
        },
        methods: {
            generateBarcode() {
                try {
                    // 塞入宏任务，确保在页面渲染完成后再生成条形码
                    setTimeout(() => {
                        if(this.barcodeOpts.text) {
                            bwipjs.toCanvas(this.$refs.barcodeCanvas, this.barcodeOpts);
                        }
                    })
                    
                } catch (e) {
                    
                    console.error(e);
                }
             },
            // 切换标签页
            onTabChange(value) {
                const item = this.barcodeList[value]
                this.barcodeOpts.text = item.value
                this.generateBarcode()
            }
        },
        props: {
            barList: {
                type: Array,
                default: () => []
            }
        },
        watch: {
            barList() {
                this.barcodeList = this.barList
                if(this.barcodeList.length > 0){
                    this.barcodeOpts.text = this.barcodeList[0].value
                    this.generateBarcode()
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.barcode {
    width: calc(100% - 40px);
    margin: 10px;
    background-color: #fff;
    height: 120px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .bar-text {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #666;
    margin-top: 5px;
  }
  .empty {
    background-color: #efefef;
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: #999;
    margin: 0 10px;
  }
  .bar-massage {
    font-size: 14px;
    color: #333;
    margin: 10px;
    font-weight: bold;
    text-align: center;
  }
</style>